import iposiApi from '../api/iposApi';

class AreasService {
  validateAddress(address, branchId) {
    const params = {
      lat: address.geometry.location.lat(),
      lng: address.geometry.location.lng(),
      branchId: branchId
    };
    return iposiApi
      .get("/ValidPoint", { params })
      .then((response) => {
        return response.data;
      });
  }
}

export default new AreasService();
